import { stringifyQueryParams } from '@core/window'
import { defaultApiHost } from '@src/helpers'

type IFetchParams = Partial<RequestInit>

const fetchDefaults: IFetchParams = {
  cache: 'no-cache',
  credentials: 'include',
  mode: 'cors',
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
  },
}

const resolveUrl = (url, baseUrl) =>
  url.startsWith('/') && !url.startsWith('//') ? baseUrl + url : url

/**
 * Fetches data from the specified URL with cache busting
 */
export const fetcher = async ({
  url,
  query = {},
  fetchParams = {},
  baseUrl = defaultApiHost,
}: {
  url: string
  query?: Record<string, unknown>
  fetchParams?: IFetchParams
  baseUrl?: string
}): Promise<Response> => {
  fetchParams = {
    ...fetchDefaults,
    ...fetchParams,
  }
  const queryPrefix = url.includes('?') ? '&' : '?'

  // Add cache buster to query params
  const queryWithCacheBuster = {
    ...query,
    _: Date.now(),
  }

  const fetchUrl =
    resolveUrl(url, baseUrl) +
    queryPrefix +
    stringifyQueryParams(queryWithCacheBuster)
  //try {
  return await fetch(fetchUrl, fetchParams)
  //} catch (e) {
  //
  // possibly failing due to adblockers blocking requests to fireworkadservices domains, filling up sentry with errors
  // Originally we were logging this error out:
  //
  // (TODO CS-7105) figure out better solution for this
  //
  // https://firework.sentry.io/issues/5747234928/?alert_rule_id=9448026&alert_type=issue&environment=production&notification_uuid=51e5afb4-12b4-406f-98d1-25172f7577e4&project=2054398&referrer=slack
  // logError(e, {
  //   captureContext: {
  //     extra: {
  //       fetchUrl,
  //       fetchParams,
  //     },
  //   },
  // })
  //throw e
  //}
}
